import { render, staticRenderFns } from "./RegisterFormIframe.vue?vue&type=template&id=24bef92a&scoped=true&"
import script from "./RegisterFormIframe.vue?vue&type=script&lang=ts&"
export * from "./RegisterFormIframe.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterFormIframe.vue?vue&type=style&index=0&id=24bef92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bef92a",
  null
  
)

export default component.exports